'use strict';
var $       = require('./$')
  , SPECIES = require('./$.wks')('species');
module.exports = function(C){
  if(require('./$.support-desc') && !(SPECIES in C))$.setDesc(C, SPECIES, {
    configurable: true,
    get: function(){ return this; }
  });
};


/** WEBPACK FOOTER **
 ** ./~/react-native-winjs/~/core-js/library/modules/$.species.js
 **/